export default __webpack_public_path__ + "static/media/rate_one.c7a2f429.png";